import { Button, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutZoneAreaQuickInfo extends Layout {
    buttonZoneAreaCode: Button;
    panelZoneAreaQuickInfo: Panel;
    sourceZoneArea: DataSource;
    textboxDescr: Textbox;
    textboxId: Textbox;
    textboxZoneRegionId: Textbox;
}
